import { action } from 'typesafe-actions';

import { INews } from 'APIPackage/NewsModule/interfaces/INews';
import { IAttachment } from 'APIPackage/NewsModule/interfaces/IAttachment';

import { NewActionsEnum } from '../enums/NewActionsEnum';

export const newsInitPage = () => action(NewActionsEnum.NEWS_INIT_PAGE);
export const newsGetData = () => action(NewActionsEnum.NEWS_GET_DATA);
export const newsSetData = (data: INews[]) => action(NewActionsEnum.NEWS_SET_DATA, { data });
export const newsSetFilterOption = (filterOption: string) =>
  action(NewActionsEnum.NEWS_SET_FILTER_OPTION, { filterOption });
export const newsGetRolesOptions = () => action(NewActionsEnum.NEWS_GET_ROLES_OPTION);
export const newsGetAnnounce = () => action(NewActionsEnum.NEWS_GET_ANNOUNCE);
export const newsSetAnnounce = (announce: INews) => action(NewActionsEnum.NEWS_SET_ANNOUNCE, { announce });
export const newsGetAttachmentNews = (id: string, file: IAttachment) =>
  action(NewActionsEnum.NEWS_GET_ATTACHMENT_NEWS, { id, file });
